import React from "react";

export default function ProgrammeFeature({ content }) {
  return (
    <div id="programmeFeature">
      <div className="subtitle">{content.subtitle}</div>
      <div className="title">{content.title}</div>
      <div className="content">
        <div className="contentLeft">
          <div className="textLeft" dangerouslySetInnerHTML={{ __html: content.textLeft }} />
          <img alt="" src={content.imageLeft.url} />
        </div>
        <div className="contentRight">
          {content.list.map((item, index) => (
            <div className="itemWrapper" key={index}>
              <img key={index} alt="" src={item.image.url} />
              <div className="itemText">
                <div className="title">{item.title}</div>
                <div className="description" dangerouslySetInnerHTML={{ __html: item.content }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
